(() => {
  const initSection = (section) => {
    if (!section || section.dataset.fctReady === 'true') return;
    section.dataset.fctReady = 'true';

    const cards = section.querySelectorAll('.funny-customer-think__card--video');

    cards.forEach((card) => {
      const video = card.querySelector('video');
      const playButton = card.querySelector('[data-fct-play]');
      if (!video) return;

      video.setAttribute('playsinline', '');

      if (playButton) {
        playButton.addEventListener('click', async () => {
          try {
            await video.play();
            playButton.classList.add('is-hidden');
          } catch (error) {
            playButton.classList.remove('is-hidden');
          }
        });

        video.addEventListener('pause', () => {
          if (!video.ended) playButton.classList.remove('is-hidden');
        });

        video.addEventListener('ended', () => {
          playButton.classList.remove('is-hidden');
        });
      }
    });

    if ('IntersectionObserver' in window) {
      const videos = Array.from(section.querySelectorAll('video[autoplay]'));
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.55, 1] }
      );

      videos.forEach((video) => observer.observe(video));
    }
  };

  const initAll = (root = document) => {
    root.querySelectorAll('.funny-customer-think').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
